import {
  AdminExamCenterLocationDetails,
  AdminExamCenterLocationDetailsPermissionRoute,
} from '@exam-center/admin-exam-center-location-details';
import { APP_PERMISSIONS } from '@exam-center/permission';
import { useParams } from '@exam-center/router';
import { WithPermission } from '@shared/permissions';

export default function AdminExamCenterLocationDetailsPage() {
  const { roomId } = useParams('/admin/exam-location/locations/:roomId');
  return (
    <WithPermission
      requiredPermission={[APP_PERMISSIONS.ADMIN_EXAM_LOCATION_MANAGEMENT.EXAM_LOCATION.VIEW]}
      errorElement={AdminExamCenterLocationDetailsPermissionRoute}
      slotProps={{
        errorElement: {
          roomId,
        },
      }}
    >
      <AdminExamCenterLocationDetails />
    </WithPermission>
  );
}
